import React from 'react';
import { Link } from 'react-router-dom';
import NotFoundImage from '../assets/images/not-found.gif';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-slate-100 p-8 flex flex-col items-center text-center">
        <Link to="/landing" className="mb-6 hover:scale-105 transition-transform duration-300">
          <img className="w-64 h-auto mx-auto object-contain" src={NotFoundImage} alt="Page not found" />
        </Link>
        <h2 className="text-2xl font-extrabold text-slate-900 mb-3 tracking-tight">Oops! Page Not Found</h2>
        <p className="text-slate-500 mb-8">The page you are looking for doesn't exist or has been moved.</p>
        
        <button 
          onClick={() => { window.location.href = "/landing" }}
          className="btn btn-primary rounded-xl px-8 shadow-sm"
        >
          <i className="pi pi-home mr-2"></i>{' '}
          Return Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;